import React,{useState,useEffect} from 'react'
import '../styles/auth.css'
import Photo from '../img/n89.png'
import AuthBg from '../img/EBD428F1-DF85-4FFB-80F5-1E799D849F44.GIF'
import {Input,PasswordInput,InputErrorMassage} from '../comps/comps'
import {useDispatch} from 'react-redux'
import {useNavigate, useSearchParams} from 'react-router-dom';
import {Helmet} from "react-helmet";
import * as actions from '../store/authAction'
import { getSignupDraft, setSignupDraft } from '../utils/signupDraft'
import { detectCountry } from '../utils/countries'
import { FaRegEye,FaRegEyeSlash,FaGoogle,FaGithub,FaApple } from "react-icons/fa";

const Auth = () => {
const dispatch = useDispatch();
const navigate = useNavigate();
const [searchParams] = useSearchParams();

const [isLogin,setLogin] = useState(false);
const [password,setPassword] = useState('');
const [email,setEmail] = useState('');
const [loginErr,setLoginErr] = useState(false);
const [passwordEye,setPasswordEye] = useState(true);
const [tried,setTried] = useState(false);
const [busy,setBusy] = useState(false);

const setSingupHandl = async () =>{
    setTried(true);
    if(email.length >= 5 && password.length === 10){
      try{
  await dispatch(actions.log_in(email,password))
      } catch(error){
        setLoginErr(error && error.message ? error.message : true)
        return
      }
navigate('../');}
}

const setLoginHandl = async () =>{
  setTried(true);
  setLoginErr(false);
  if(email.length < 5 || email.length > 80) return
  setBusy(true)
  try {
    const sent = await actions.send_code(email)
    setSignupDraft({ email, emailVerified: false, codePreview: sent && sent.preview ? sent.preview : '' })
    navigate('/auth/setup/code')
  } catch (error) {
    setLoginErr(error && error.message ? error.message : 'Could not send the code')
  }
  setBusy(false)
}

const finishSocialSignup = (data) => {
  setSignupDraft({
    email: data.email,
    name: data.name || '',
    password: data.password,
    emailVerified: true,
    social: true
  })
  navigate(data.name && data.name.length >= 3 ? '/auth/setup/bio' : '/auth/setup/name')
}

const onGoogle = () => {
  window.location.assign('/api/auth/google/start')
}

useEffect(() => {
  const html = document.documentElement;
  const body = document.body;
  const prev = {
    htmlOverflow: html.style.overflow,
    bodyOverflow: body.style.overflow,
    bodyPosition: body.style.position,
    bodyTop: body.style.top,
    bodyWidth: body.style.width,
    bodyHeight: body.style.height,
    bodyOverscroll: body.style.overscrollBehavior
  };
  html.style.overflow = 'hidden';
  body.style.overflow = 'hidden';
  body.style.position = 'fixed';
  body.style.top = '0';
  body.style.width = '100%';
  body.style.height = '100%';
  body.style.overscrollBehavior = 'none';
  return () => {
    html.style.overflow = prev.htmlOverflow;
    body.style.overflow = prev.bodyOverflow;
    body.style.position = prev.bodyPosition;
    body.style.top = prev.bodyTop;
    body.style.width = prev.bodyWidth;
    body.style.height = prev.bodyHeight;
    body.style.overscrollBehavior = prev.bodyOverscroll;
  };
}, []);

useEffect(() => {
  const draft = getSignupDraft();
  if (draft.email) setEmail(draft.email);
}, []);

useEffect(() => {
  detectCountry().then(country => {
    if (country) setSignupDraft({ country });
  });
}, []);

useEffect(() => {
  const why = searchParams.get('error')
  if (!why) return
  if (why === 'github' || why === 'github-email' || why === 'google' || why === 'apple' || why === 'blocked') {
    setLoginErr(
      why === 'blocked' ? 'This account is blocked'
        : why === 'google' ? 'Google sign in failed'
        : why === 'apple' ? 'Apple sign in is not set up yet'
        : why === 'github-email' ? 'GitHub did not share a verified email'
        : 'GitHub sign in is not set up yet'
    )
    navigate('/auth', { replace: true })
  }
}, [searchParams, navigate])

return(
  <section className="Auth isSignup">
    <Helmet>
    <title>Login</title>
  <meta name="description" content='here you can create a new acount or sing in  '/>
<meta name='keywords' content='singin,login,enveraworld website,singin page,login page'/>
     <link rel="canonical" href="https://pinweelo.com/auth" />
    </Helmet>
    <img className="authBgGif" src={AuthBg} alt="" />
    <div className='divin'>
    <div className="authLogoSlot"><img className='authSvg' src={Photo} alt="" /></div>
    <div className="authFormCenter">
<Input placeholder='Enter Your Email' value={email} onChange={e=>{setEmail(e.target.value)}} />
{tried && <InputErrorMassage val={email} num={[5,35]} text='email should be 3 to 35 letters' />}
  {!isLogin && (
    <>
      <PasswordInput show={<FaRegEyeSlash />} showed={<FaRegEye />} passwordEyeAction={ () => {setPasswordEye(prev => !prev)}} eye={passwordEye} type={"password"} placeholder='Enter Your Password' value={password} onChange={e=>{setPassword(e.target.value)}} />
      {tried && <InputErrorMassage val={password} num={[10,10]} text='password should be 10 letters' />}
    </>
  )}

     <button type="button" onClick={isLogin ? setLoginHandl : setSingupHandl} className='googlebuttons' disabled={busy}>{busy ? 'Please wait…' : (isLogin ? 'Sign up' : 'Log in')}</button>
     <p onClick={()=>{setLogin(prev => !prev); setTried(false); setLoginErr(false);}} className='googlebuttonss'>
      {isLogin
        ? <>I have an account <span className="authSwitchLink">Sign in</span></>
        : <>Don't have an account? <span className="authSwitchLink">Sign up</span></>}
     </p>

  {loginErr ? <p className="InputErrorMassage">{typeof loginErr === 'string' ? loginErr : 'wrong user name or password'}</p> : null}
    </div>

    <div className="authSocial">
      <p className="authSocialLabel">{isLogin ? 'Sign up with' : 'Or continue with'}</p>
      <div className="authSocialRow">
        <button type="button" className="authSocialBtn" onClick={onGoogle} disabled={busy} aria-label="Continue with Google">
          <FaGoogle />
        </button>
        <button type="button" className="authSocialBtn" onClick={onGoogle} disabled={busy} aria-label="Continue with Apple">
          <FaApple />
        </button>
        <button type="button" className="authSocialBtn" onClick={onGoogle} disabled={busy} aria-label="Continue with GitHub">
          <FaGithub />
        </button>
      </div>
    </div>
</div>
  </section>
  )
}
export default Auth;
